import React from 'react';
interface BonusMockupProps {
  number: number;
  icon: string;
  coverColor: string;
}
export function BonusMockup({
  number,
  icon,
  coverColor
}: BonusMockupProps) {
  return <div className="relative w-44 h-60 mx-auto" data-id="element-13" data-mp="3b0bqlsgvbipu">
      {/* Drop shadow base */}
      <div className="absolute inset-0 translate-x-1 translate-y-2 bg-black/10 rounded-xl blur-md" data-id="element-14" data-mp="3b2eoeyo9ig54"></div>

      {/* Book cover */}
      <div className="relative w-full h-full rounded-xl shadow-xl overflow-hidden flex flex-col justify-between p-6" style={{
      backgroundColor: coverColor
    }} data-id="element-15" data-mp="311w0nstkufhx">
        {/* Spine highlight */}
        <div className="absolute left-0 top-0 bottom-0 w-3 bg-black/10" data-id="element-16" data-mp="2salxd9sr7501"></div>
        <div className="absolute left-3 top-0 bottom-0 w-px bg-white/20" data-id="element-17" data-mp="2nbiqdjt7qopf"></div>

        <div className="text-3xl" data-id="element-18" data-mp="2ibd6wqx3k8if">{icon}</div>

        <div data-id="element-19" data-mp="2iablptmda5mz">
          <div className="text-white text-2xl font-black mb-4" data-id="element-20" data-mp="2iav050ct6bw9">
            Bonus {number}
          </div>
          <div className="h-px bg-white/40 mb-4" data-id="element-21" data-mp="2demr84p7fexj"></div>
          <div className="text-white/80 text-xs font-bold tracking-widest" data-id="element-22" data-mp="3kqspwgfqcfga">
            STRETCHING 360™
          </div>
        </div>
      </div>
    </div>;
}